import { Box, Tab, Tabs } from '@mui/material';
import React from 'react'
import { TabHeaderType } from '../../types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface TabHeaderProps {
    tabsItems: TabHeaderType[],
    onChange: (value: number) => void,
    selected: number
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function TabHeader({ tabsItems = [], onChange, selected }: TabHeaderProps) {

    const handleChange = (_: React.SyntheticEvent<Element, Event>, newValue: number) => {
        onChange(newValue)
    };

    return (
        <Box sx={{ bgcolor: 'background.paper', width: "100%", marginTop: '1rem' }}>
            <Tabs
                value={selected}
                onChange={handleChange}
                aria-label="sdk tabs"
                variant="fullWidth"
                indicatorColor="primary"
                textColor="inherit"
            >
                {tabsItems.map((t, index) => <Tab
                    key={index}
                    label={<div className='d-flex-center'>
                        {t.icon && <FontAwesomeIcon icon={t.icon} />}
                        <label className='m-auto p-l-1 pointer'>{t.label}</label>
                    </div>}
                    {...a11yProps(index)}
                />)}
            </Tabs>
        </Box>
    )
}

export default TabHeader